import getConfig from 'next/config';

const { assetPrefix } = getConfig().publicRuntimeConfig;

if (typeof window !== 'undefined') {
  const analytics = window.analytics || {};
  if (analytics.firstLoad === undefined) {
    const whitelist = /^(?!(^|.*\.)(?:binance\.(com|com\.|co|cloud|top|vision|sg|co\.ug|eu|net|charity))$).*$/;
    const { hostname } = window.location;
    if (hostname.match(whitelist) &&
    !window.location.href.startsWith('file://') &&
    !window.location.href.startsWith('https://translate.googleusercontent.com/') &&
    !window.location.href.startsWith('https://www.translatoruser.net/')) {
      ((d, t) => {
        const g = d.createElement(t);
        const s = d.getElementsByTagName(t)[0];
        const server = `${assetPrefix}/static/a.min.js`;
        g.src = server;
        g.setAttribute('async', '');
        s.parentNode.insertBefore(g, s.nextSibling);
      })(document, 'script');
    }
    analytics.firstLoad = false;
  }
}
